import { mxShape } from 'mxgraph-js';
import HCLTreeVertex from '../../HCLTreeNode/HCLTreeVertex';
import HouseEventVertex from "../../HCLTreeNode/FaultTreeNode/HouseEventNode/HouseEventVertex";

class TransferGateVertexDefaultShape extends mxShape {
  public static HEIGHT = HCLTreeVertex.SHAPE.HEIGHT;

  public static WIDTH = HCLTreeVertex.SHAPE.WIDTH;

  public static RADIUS = HCLTreeVertex.SHAPE.RADIUS;

  public static GATE = HCLTreeVertex.SHAPE.GATE;

  paintVertexShape(c: any, x: any, y: any, w: any, h: any): void {
    const gateSize = h * 0.28;
    const halfSize = gateSize / 2;

    c.translate(x, y);
    c.begin();
    c.moveTo(w * 0.5, h - gateSize + 1);
    c.lineTo(w * 0.5 - halfSize, h);
    c.lineTo(w * 0.5 + halfSize, h);
    c.close();
    c.fillAndStroke();

    const radius = HCLTreeVertex.SHAPE.RADIUS;
    c.roundrect(0, 0, w, h - gateSize, radius, radius);
    c.fillAndStroke();
  }

  public static get typeString(): string {
    return 'TransferGateVertexDefaultShape';
  }
}

export default TransferGateVertexDefaultShape;
